
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/webinars/whatsapp-funnels",
      function () {
        return require("private-next-pages/webinars/whatsapp-funnels.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/webinars/whatsapp-funnels"])
      });
    }
  